import { v4 as uuidv4 } from "uuid";

/**
 * Generates a unique internal ID for tracking items in the form
 */
export const generateInternalId = (): string => {
  return `internal_${uuidv4()}`;
};
